import { Filter } from '../../Enum/Filters';
import { FilterDTO } from '../../Interface/Hook/Interest/FilterDTO';
import { FilterState } from '../../Store/Filter/state';
import { RootState } from '../../Store';

import { useSelector } from 'react-redux';

const useGetFilteredValues = (): FilterDTO => {
    const filterValues = useSelector<RootState, FilterState>(state => state.filter);
    const constructionType = filterValues.filteredValues[Filter.ConstructionType];
    const energyLabel = filterValues.filteredValues[Filter.EnergyLabel];
    const fixedPeriod = filterValues.filteredValues[Filter.FixedPeriod];
    const fixedPeriods = filterValues.filteredValues[Filter.FixedPeriods];
    const label = filterValues.filteredValues[Filter.Label];
    const labels = filterValues.filteredValues[Filter.Labels];
    const loanForm = filterValues.filteredValues[Filter.LoanForm];
    const modificationLoanForm = filterValues.filteredValues[Filter.ModificationLoanForm];
    const newsLabels = filterValues.filteredValues[Filter.NewsLabels];
    const nhg = filterValues.filteredValues[Filter.NHG];
    const mortgageProperties = filterValues.filteredValues[Filter.MortgageProperties];
    const riskCategory = filterValues.filteredValues[Filter.RiskCategory];
    const dateFrom = filterValues.filteredValues[Filter.DateFrom];
    const dateTo = filterValues.filteredValues[Filter.DateTo];
    const clientType = filterValues.filteredValues[Filter.ClientType];
    const bridgingLoanLabels = filterValues.filteredValues[Filter.BridgingLoanLabels];
    const account = filterValues.filteredValues[Filter.Account];

    return {
        constructionType,
        energyLabel,
        fixedPeriod,
        fixedPeriods,
        label,
        labels,
        loanForm,
        modificationLoanForm,
        newsLabels,
        nhg,
        mortgageProperties,
        riskCategory,
        dateFrom,
        dateTo,
        clientType,
        bridgingLoanLabels,
        account,
    };
};

export default useGetFilteredValues;
